import React, { useContext } from 'react';
import { EditContext } from '../context/EditContext';

const SUPPORTED_KINDS = new Set(['config', 'services', 'testimonials', 'portfolio_category']);

export default function Editable({ descriptor, children, style }) {
  const { editMode, openEditor } = useContext(EditContext);

  if (!editMode || !descriptor || !SUPPORTED_KINDS.has(descriptor.kind)) {
    return <>{children}</>;
  }

  return (
    <div className="editable" style={style}>
      {children}
      <button
        type="button"
        className="editable-pencil"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); openEditor(descriptor); }}
        title={descriptor.label || 'Edit'}
        aria-label={`Edit ${descriptor.label || 'region'}`}
      >
        <span aria-hidden="true">✎</span> Edit
      </button>
    </div>
  );
}
